module.exports = __webpack_public_path__ + "static/ctg-mta-dash-fc60e9b4ba6ff574a10f6f7579a6235a.jpg";